<template>
  <o-form-group :label="label" :error-field="errorField" :class="{'has-error': errorField in $root.errors}">
    <div class="w-100 role">
      <b-form-checkbox-group v-if="hasOptions" v-model="localValue" :options="options" name="roles" class="pb-0">
        {{ options.name }}
      </b-form-checkbox-group>
    </div>
  </o-form-group>
</template>

<style>
  .role .custom-control-label {
    padding: 0 !important;
  }
</style>

<script>
  import axios from 'axios'

  export default {
    name: 'o-role',
    props: {
      value: {
        default: null
      },
      label: {
        type: String
      },
      errorField: {
        type: String
      },
      url: {
        type: String,
        required: true
      }
    },

    data: () => ({
      localValue: [],
      options: []
    }),

    mounted() {
      this.fetch()
      this.localValue = this.value
    },

    computed: {
      hasOptions() {
        return this.options.length > 0
      }
    },

    watch: {
      value(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.localValue = newVal
        }
      },
      localValue(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('input', newVal)
        }
      }
    },

    methods: {
      fetch() {
        var $self = this
        axios.get($self.url).then((response) => {
          response.data.data.forEach(function (role) {
            var text = role.name
            if (role.description) {
              text += ` (${role.description})` 
            }
            $self.options.push({ text: text, value: role})
          })
        })
      }
    }
  }
</script>
